<template>
  <div class="products-filter">
    <bp-select
      v-model="form.status"
      class="mb-5"
      label="Status"
      :options="[
        { id: '', name: 'Todos' },
        { id: 'active', name: 'Ativo' },
        { id: 'draft', name: 'Pendente' },
        { id: 'inactive', name: 'Inativo' },
        { id: 'reject', name: 'Rejeitado' },
        { id: 'in_review', name: 'Em revisão' }
      ]"
    />

    <bp-select
      v-model="form.type_product"
      class="mb-5"
      label="Tipo de Produto"
      :options="[
        { id: '', name: 'Todos' },
        { id: 'online_course', name: 'Curso online' },
        { id: 'signature', name: 'Assinatura' },
        { id: 'onsite_event', name: 'Evento presencial' }
      ]"
    />

    <calendar-picker
      v-model="form.dates"
      class="mb-5"
      position-relative
      label="Período de criação do produto"
    />

    <div class="d-flex flex-column flex-lg-row gap-5 justify-content-end mt-7">
      <bp-button
        label="Cancelar"
        color="neutral"
        variant="filled-1"
        @click="$emit('close')"
      />
      <bp-button label="Aplicar" @click="submit" />
    </div>
  </div>
</template>
<script>
import { formFields } from "@/functions/helpers";
export default {
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      ...formFields(["status", "type_product", "dates"], {
        ...this.params,
        dates: [this.params.created_at_after, this.params.created_at_before]
      })
    };
  },
  methods: {
    submit() {
      const data = {
        ...this.form,
        created_at_after: this.form.dates[0],
        created_at_before: this.form.dates[1]
      };
      delete data.dates;

      this.$emit("close");
      this.$emit("submit", data);
    }
  }
};
</script>
